const nroAfiliadoFilter = (nroAfiliado, integrante) => {
  nroAfiliado = nroAfiliado.toString()
  integrante = integrante.toString()

  return `${nroAfiliado.slice(0, 1)}-${nroAfiliado.slice(1)}/${integrante}`
}

export default nroAfiliadoFilter
